import introImageMb from "../images/image-intro-mobile.jpg";
import introImageDT from "../images/image-intro-desktop.jpg";

function Intro() {
	const innerWidth = window.matchMedia("(max-width: 375px)").matches;
	return (
		<section className="intro text-center">
			<div className="container">
				<div className="image desktop">
					<img src={innerWidth ? introImageMb : introImageDT} alt="" />
				</div>
				<div className="content">
					<h1 className="title dm">Humanizing your insurance</h1>
					<p className="desc">
						Get your life insurance coverage easier and faster. We blend our
						expertise and technology to help you find the plan that’s right for
						you. Ensure you and your loved ones are protected
					</p>
					<button className="btn cta">View plans</button>
				</div>
			</div>
		</section>
	);
}

export default Intro;
